<template>
    <div v-if="!loading" class="pb-25">
        <h3 class="mb-2 text-primary mt-50">درخواست‌های سالن‌دار</h3>
        <b-card v-if="desks.length" class="p-0" no-body>
            <b-table responsive :items="desks" :fields="fields" class="mb-0" striped>
                <template #cell(pagedAt)="data">
                    {{ new Date(data.item.pagedAt).toLocaleTimeString('fa-IR').split(":").slice(0, 2).join(":") }}
                </template>
                <template #cell(checked)="data">
                    <b-button @click="check(data.item.id, data.item.pagedAt)" :disabled="data.item.checked"
                        :variant="data.item.checked ? 'success' : 'warning'" class="btn-icon rounded-circle p-50">
                        <feather-icon :icon="data.item.checked ? 'CheckIcon' : 'XIcon'" />
                    </b-button>
                </template>
            </b-table>
        </b-card>
        <h5 v-else class="d-flex align-items-center justify-content-center" style="min-height: 63vh;">
            موردی وجود ندارد
        </h5>
    </div>
</template>

<script>
import { BCard, BCardText, BCardBody, BButton, BRow, BCol, BTable } from 'bootstrap-vue';
import * as signalR from '@microsoft/signalr'

export default {
    components: {
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BRow,
        BCol,
        BTable
    },
    data() {
        return {
            loading: true,
            desks: [],
            connection: null,
            fields: [
                {
                    key: 'id',
                    label: 'میز',
                },
                {
                    key: 'pagedAt',
                    label: 'زمان',
                },
                {
                    key: 'checked',
                    label: 'وضعیت',
                },
            ],
            notification: null,
            selfStop: false,
            reconnecting: false,
        }
    },
    methods: {
        async startConnection() {
            const connection = new signalR.HubConnectionBuilder()
                .withUrl(`${process.env.VUE_APP_BASE_URL_Socket}hubs/pager`, {
                    accessTokenFactory: () => localStorage.getItem("accessToken"),
                    withCredentials: false,
                    transport: signalR.HttpTransportType.WebSockets,
                })
                .configureLogging(signalR.LogLevel.Critical)
                .build();
            this.connection = connection;
            this.connection.on('SyncDesks', desks => {
                this.desks = desks;
                this.loading = false;
            });

            this.connection.on('DeskPaged', desk => {
                desk.checked = false;
                this.desks.unshift(desk);
                this.playNotification1();
                this.$notif({ type: 'success', title: 'یک درخواست جدید ثبت شده است' });
                if (this.desks.length > 30) {
                    this.desks.pop();
                }
            });
            this.connection.on('DeskChecked', desk => {
                const target = this.desks.find(item => item.id === desk.id && item.pagedAt === desk.pagedAt);
                if (target) {
                    target.checked = true;
                }
            });
            this.connection.onclose(async () => {
                if (!this.reconnecting && !this.selfStop) {
                    this.reconnecting = true;
                    await this.reconnect();
                }
            });
            try {
                await this.connection.start();
                this.reconnecting = false;
            } catch (err) {
                this.reconnect();
            }
        },
        async reconnect() {
            if (this.selfStop) {
                return;
            }
            setTimeout(async () => {
                try {
                    await this.startConnection();
                } catch (err) {
                    this.reconnect();
                }
            }, 5000);
        },
        async check(id, pagedAt) {
            await this.connection.send('CheckDesk', {
                deskId: id,
                pagedAt,
            });
        },
        playNotification1() {
            this.notification.pause();
            this.notification.currentTime = 0;
            this.notification.play();
        }
    },
    async mounted() {
        const soundPath = require('@/assets/sound/notification1.mp3');
        this.notification = new Audio(soundPath);
        await this.startConnection();
    },

    beforeDestroy() {
        this.selfStop = true;
        if (this.connection) {
            this.connection.stop();
        }
    }
};
</script>
